import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SelectVerificationsItemComponent from './SelectVerificationsItemComponent';
import SearchComponent from './SearchComponent';
import { Typography } from '@totalsoft/rocket-ui';
import PaginationWrapper from 'components/common/PaginationWrapper';
import WrappedFakeText from 'components/common/WrappedFakeText';

const SelectVerificationsComponent = ({
  verifications,
  verificationsOnPage,
  handleExistingVerificationSelection,
  totalCount,
  pageSize,
  page,
  rowsPerPageOptions,
  handleChangeRowsPerPage,
  handleChangePage,
  handleRefresh,
  filter,
  handleFilterValueChanged,
  handleResetFilters,
  entitiesLoaded
}) => {
  const [t] = useTranslation();

  const onExistingVerificationSelection = (idx, partnerName, isSelected) => {
    const listIndex = verifications.findIndex(elem => verificationsOnPage[idx].verificationId === elem.verificationId);
    handleExistingVerificationSelection(listIndex, partnerName, isSelected);
  };

  return (
    <>
      <Typography variant='h6'>{t('OfferEdit.Client.Verification.ExistingChecksChoice')}</Typography>
      <Grid container spacing={1} justifyContent={'flex-end'}>
        <Grid item xs={6}>
          <SearchComponent filter={filter} onFilterValueChanged={handleFilterValueChanged} handleResetFilters={handleResetFilters} />
        </Grid>
      </Grid>
      <Grid container sx={{ textAlign: 'center' }}>
        <Grid item xs={12}>
          {!entitiesLoaded && <WrappedFakeText lines={5} my={2} />}
          {entitiesLoaded && (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>{t('OfferEdit.Client.Verification.Type')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.Client.Verification.Entity')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.Client.Verification.Date')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.Client.Verification.State')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.Client.Verification.ValidityDate')}</strong>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {verificationsOnPage.map((item, idx) => {
                  return (
                    <SelectVerificationsItemComponent
                      item={item}
                      key={item.verificationId}
                      selectVerificationForReinterogation={() => onExistingVerificationSelection(idx, item.partnerName, item.isSelected)}
                    />
                  );
                })}
              </TableBody>
            </Table>
          )}
        </Grid>
        {entitiesLoaded && (
          <Grid item xs={12} container justifyContent='flex-end'>
            <PaginationWrapper
              count={totalCount}
              pageSize={pageSize}
              page={page}
              rowsPerPageOptions={rowsPerPageOptions.current}
              onRowsPerPageChange={handleChangeRowsPerPage}
              onPageChange={handleChangePage}
              onRefresh={handleRefresh}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

SelectVerificationsComponent.propTypes = {
  verifications: PropTypes.array.isRequired,
  verificationsOnPage: PropTypes.array.isRequired,
  handleExistingVerificationSelection: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  handleFilterValueChanged: PropTypes.func.isRequired,
  handleResetFilters: PropTypes.func.isRequired,
  entitiesLoaded: PropTypes.bool.isRequired
};

export default SelectVerificationsComponent;
